export const SEARCH_TERMS = ["heading"];
export const inputFields = {
  heading: {
    type: "string",
    required: true,
    title: "Heading",
    inputType: "text",
  },
  description: {
    type: "string",
    required: true,
    title: "Description",
    inputType: "text",
  },
  featured_image: {
    type: "file",
    required: false,
    title: "Featured Image",
  },
};
export const initialValues = {
  heading: "",
  description: "",
};

export const view_all_table = [
  { name: "Heading", value: "heading" },
  { name: "Description", value: "description" },
];
